const user_management = {
	dialog: {
		add_user_first_impersonate: {
			alert:
				"Om een gebruiker toe te voegen moet u eerst een administrator van debiteur <strong>{{debtor_code}}</strong> impersonaten.",
			to_impersonate_page_button: "Naar impersonaten",
		},
		block: {
			description: "Weet u zeker dat u de gebruiker <strong>{{username}}</strong> wilt blokkeren?",
			success_alert: "Gebruiker succesvol geblokkeerd!",
			title: "Gebruiker blokkeren",
		},
		deblock: {
			description:
				"Weet u zeker dat u de gebruiker <strong>{{username}}</strong> wilt deblokkeren?",
			success_alert: "Gebruiker succesvol gedeblokkeerd!",
			title: "Gebruiker deblokkeren",
		},
		delete: {
			delete_last_admin:
				"Ik ben me ervan bewust dat ik hiermee de laatste admin gebruiker van debiteur <strong>{{debtor}}</strong> verwijder.",
			description:
				"Weet u zeker dat u de gebruiker <strong>{{username}}</strong> wilt verwijderen?",
			otp_invalid: "2FA-code onjuist!",
			otp_not_enabled: "Voordat u gebruikers kunt verwijderen, moet u eerst 2FA inschakelen.",
			success_alert: "Gebruiker succesvol verwijderd!",
			title: "Gebruiker verwijderen",
		},
		disable_otp: {
			description: "Weet je zeker dat je 2FA wilt uitschakelen voor <strong>{{user}}</strong>?",
			messages: {
				success: "2FA succesvol verwijderd voor <strong>{{user}}</strong>!",
			},
			otp_first: "Activeer eerst 2FA voordat je deze kunt uitschakelen voor een gebruiker.",
			otp_invalid: "2FA-code onjuist!",
			otp_not_enabled: "2FA is niet ingeschakeld voor deze gebruiker",
			submit_button: "Uitschakelen",
			title: "2FA uitschakelen",
		},
		impersonate: {
			description:
				"Weet u zeker dat u de gebruiker <strong>{{username}}</strong> wilt impersonaten?",
			otp_invalid: "2FA-code onjuist!",
			otp_not_enabled: "Voordat u gebruikers kunt impersonaten, moet u eerst 2FA inschakelen.",
			title: "Gebruiker impersonaten",
		},
	},
	membership_type: {
		business: "Business",
		label: "Selecteer type debiteur",
		private: "Private",
	},
	show_disabled: "Laat verwijderde gebruikers zien",
	table: {
		body: {
			buttons: {
				block: "Blokkeren",
				deblock: "Deblokkeren",
				disable_otp: "2FA uitschakelen",
				impersonate: "Impersonate",
			},
			otp: {
				disabled: "2FA uitgeschakeld",
				enabled: "2FA ingeschakeld",
			},
		},
		headers: {
			categories: "Labels",
			company: "Bedrijfsnaam",
			debtor_code: "Debiteur nummer",
			email_address: "E-mailadres",
			language: "Taal",
			membership_type: "Type account",
			otp: "2FA",
			phone_number: "Telefoonnummer",
			user_id: "User ID",
			username: "Gebruikersnaam",
		},
	},
	title: "Gebruikers",
};

export default user_management;
